import { render, staticRenderFns } from "./TextBase.vue?vue&type=template&id=4ea6e0c6&scoped=true&"
import script from "./TextBase.vue?vue&type=script&lang=js&"
export * from "./TextBase.vue?vue&type=script&lang=js&"
import style0 from "./TextBase.vue?vue&type=style&index=0&id=4ea6e0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6e0c6",
  null
  
)

export default component.exports